import { useLoginState } from 'src/app/shared/hooks/session';

import type { PromotePageData } from '../../../index';

type Result = {
	enabled: boolean;
	userData: {
		name: string;
		email: string;
		firstName: string;
		lastName: string;
	};
};

export function usePrefilledGuestData(): (pageData: PromotePageData) => Result {
	const loginState = useLoginState();
	return function prefillGuestUserData(pageData): Result {
		const { guestUserData, user } = pageData;

		if (loginState !== 'GUEST') {
			return {
				enabled: false,
				userData: {
					name: user.displayName,
					email: user.email,
					firstName: '',
					lastName: '',
				},
			};
		}

		const { firstName, lastName, email } = guestUserData || { firstName: '', lastName: '', email: '' };

		return {
			enabled: true,
			userData: {
				firstName,
				lastName,
				email,
				name: `${firstName} ${lastName}`,
			},
		};
	};
}
